import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  SimpleChanges
} from '@angular/core';

import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import 'froala-editor/js/froala_editor.pkgd.min.js';
import 'froala-editor/js/languages/zh_cn.js';
@Component({
  selector: 'nz-wysiwyg-net',
  preserveWhitespaces: false,
  templateUrl: './wysiwyg-net.component.html',
})

export class NzWysiwygNetComponent implements OnInit, OnChanges {

  constructor(public el:ElementRef) {
  }

  @Output('onHtmlChange') onHtmlChange: EventEmitter<any> = new EventEmitter;
  @Input('options') otherOptions: Object;
  @Input('HTML') editorContent: string;
  public options: Object = {
    placeholderText: "è¾å¥åå®¹...",
    language: 'zh_cn',
    events : {
      'froalaEditor.html.get' : (e, editor, html) => {
        this.onHtmlChange.emit(html);
      }
    }
  }

  ngOnInit(): void {
    this.options = {...this.options, ...this.otherOptions};
    this.el.nativeElement.onload = () => {
      this.removeLicense();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes) {
      this.removeLicense();
    }
  }

  removeLicense(): void {
    let license: Node = this.el.nativeElement.querySelector("a[href='https://www.froala.com/wysiwyg-editor?k=u']");
    if (license) {
      license.parentNode.parentNode.removeChild(license.parentNode);
    }
  }
}
